import { render, staticRenderFns } from "./Aneis.vue?vue&type=template&id=1bc72885&"
import script from "./Aneis.vue?vue&type=script&lang=js&"
export * from "./Aneis.vue?vue&type=script&lang=js&"
import style0 from "./Aneis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports